import { Box, Grid, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import IButton from '../../../components/button/i-button.component';
import { isEmpty } from '../../common/util.services';

const TextComponent = (props: any) => {
  const [cellValue, setCellValue] = useState(null);

  useEffect(() => {
    let value;
    if(props.label === 'Description') {
      value = null === cellValue ? props.data.description : cellValue;
    } else if(props.label === 'Flow Remarks') {
      value = null === cellValue ? props.data.flowRemarks : cellValue;
    } else if(props.label === 'Output Details') {
      value = null === cellValue ? props.data.outputDesc : cellValue;
    } else if(props.label === 'Product Remarks') {
      value = null === cellValue ? props.data.productRemarks : cellValue;
    } else if(props.label === 'Order Remarks') {
      value = null === cellValue ? props.data.orderRemarks : cellValue;
    } else if(props.label === 'Product') {
      value = null === cellValue ? props.data.product : cellValue;
    } else if(props.label === 'Color') {
      value = null === cellValue ? props.data.color : cellValue;
    } else if(props.label === 'Size') {
      value = null === cellValue ? props.data.size : cellValue;
    } else if(props.label === 'Task Comments') {
      value = null === cellValue ? props.data.comments : cellValue;
    }

    setCellValue(value);
  });
 
  const onOk = () => {
    if(props.label === 'Description') {
      props.data.description = cellValue;
    } else if(props.label === 'Flow Remarks') {
      props.data.flowRemarks = cellValue;
    } else if(props.label === 'Output Details') {
      props.data.outputDesc = cellValue;
    } else if(props.label === 'Product Remarks') {
      props.data.productRemarks = cellValue;
    } else if(props.label === 'Order Remarks') {
      props.data.orderRemarks = cellValue;
    } else if(props.label === 'Product') {
      props.data.product = cellValue;
    } else if(props.label === 'Color') {
      props.data.color = cellValue;
    } else if(props.label === 'Size') {
      props.data.size = cellValue;
    } else if(props.label === 'Task Comments') {
      props.data.comments = cellValue;
    }
    
    props.close('Ok');
  }

  const onCancel = () => {
    props.close('Cancel');
  }

  const updateCellValue = (e: any) => {
    setCellValue(e.target.value);
  }

  const getMainComponent = () => {
    return <Grid container spacing={0}>
      <Grid xs={12}>
        <TextField name='cellValue' label={props.label} multiline={isEmpty(props.multiline) ? true : props.multiline} fullWidth={true}
          variant="outlined" rows={10} value={cellValue} onChange={updateCellValue} InputLabelProps={{ shrink: true }}/>
      </Grid>
      <Box display="flex" justifyContent="center" width="100%" mt={2}>
        <IButton name='submit' label='Submit' color="primary" onActionEvent={onOk}/>
        <IButton name='cancel' label='Cancel' color="secondary" onActionEvent={onCancel}/>
      </Box>
    </Grid>
  }

  return getMainComponent()
}

export default TextComponent;